export default {
  name: "App"
};